import {ScreenSequence } from "../Sequences";
import {PretestScreen1 } from "./PretestScreen1";


export const PretestKey = "Pretest";

export const PretestSequence: ScreenSequence = {
    name: "Ökonomische Kompetenzen - Was kannst du schon?",
    description: "In diesem Fragebogen findest du Fragen zu wirtschaftlichen Themen und Fragestellungen. Das Ziel dieses Fragebogens ist es, herauszufinden, was du über wirtschaftliche Themen und Entwicklungen denkst. Wir möchten deine Meinung dazu erfahren. ",
    group: "Testing", // <---- hinzugefügt!
    screens: [
        { component: PretestScreen1,
            canContinueDefault: false,  // Nur hier!
}        // UltimatumScreen2Config,
        // Add more screens/configs here if needed
    ]
};

